import { Grid, SxProps } from '@mui/material';
import React from 'react';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    customStyles?: SxProps;
}

const CustomTQLEditorTabPanel = ({
    children,
    index,
    value,
    customStyles,
    ...other
}: TabPanelProps): React.JSX.Element => {
    return (
        <Grid
            sx={customStyles}
            role='tabpanel'
            hidden={value !== index}
            id={`tql-editor-tabpanel-${index}`}
            aria-labelledby={`tql-editor-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </Grid>
    );
};

export default CustomTQLEditorTabPanel;
